export const HOLD_CLEANING_MOCK_STORAGE_KEY = "holdCleaningMockEnabled";
export const HOLD_CLEANING_MOCK_QUERY_PARAM = "mockHoldCleaning";

const readQueryOverride = (): boolean | null => {
  if (typeof window === "undefined") return null;
  const value = new URLSearchParams(window.location.search).get(HOLD_CLEANING_MOCK_QUERY_PARAM)?.toLowerCase();
  if (["1", "true", "on"].includes(value ?? "")) return true;
  if (["0", "false", "off"].includes(value ?? "")) return false;
  return null;
};

export const setHoldCleaningMockEnabled = (enabled: boolean) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(HOLD_CLEANING_MOCK_STORAGE_KEY, String(enabled));
};

export const isHoldCleaningMockEnabled = (): boolean => {
  if (typeof window === "undefined") return false;
  const override = readQueryOverride();
  if (override !== null) {
    setHoldCleaningMockEnabled(override);
    return override;
  }
  return window.localStorage.getItem(HOLD_CLEANING_MOCK_STORAGE_KEY) === "true";
};

export const disableHoldCleaningMock = () => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(HOLD_CLEANING_MOCK_STORAGE_KEY);
  const url = new URL(window.location.href);
  url.searchParams.delete(HOLD_CLEANING_MOCK_QUERY_PARAM);
  window.location.assign(url.toString());
};
